export enum InstallerPlatform {
  Windows = "Windows",
  WindowsX64 = "WindowsX64",
  Windows7 = "Windows7",
  Windows7X64 = "Windows7X64",
  Windows2003 = "Windows2003",
  Windows2003X64 = "Windows2003X64",
  Windows2003X86 = "Windows2003X86",
  Windows2000 = "Windows2000",
  Windows2000X86 = "Windows2000X86",
  Windows2000X64 = "Windows2000X64",
  LinuxX64 = "LinuxX64",
  Mac = "Mac",
}

export enum ConfigPlatform {
  Windows = "Windows",
  Windows7 = "Windows7",
  Windows2003 = "Windows2003",
  Windows2000 = "Windows2000",
  LinuxX64 = "LinuxX64",
  Mac = "Mac",
}

export const visibleConfigPlatforms: ConfigPlatform[] = [
  ConfigPlatform.Windows,
  ConfigPlatform.Windows7,
  ConfigPlatform.Windows2003,
  ConfigPlatform.LinuxX64,
];

export const installerPlatformLabels: Record<InstallerPlatform, string> = {
  [InstallerPlatform.Windows]: "Windows",
  [InstallerPlatform.WindowsX64]: "Windows 10/2012+",
  [InstallerPlatform.Windows7]: "Windows 7",
  [InstallerPlatform.Windows7X64]: "Windows 7 / 2008",
  [InstallerPlatform.Windows2003]: "Windows 2003",
  [InstallerPlatform.Windows2003X64]: "Windows 2003",
  [InstallerPlatform.Windows2003X86]: "Windows 2003 X86",
  [InstallerPlatform.Windows2000]: "Windows 2000",
  [InstallerPlatform.Windows2000X86]: "Windows 2000 X86",
  [InstallerPlatform.Windows2000X64]: "Windows 2000",
  [InstallerPlatform.LinuxX64]: "Linux",
  [InstallerPlatform.Mac]: "macOS",
};

export const configPlatformLabels: Record<ConfigPlatform, string> = {
  [ConfigPlatform.Windows]: "Windows 10/2012+",
  [ConfigPlatform.Windows7]: "Windows 7 / 2008",
  [ConfigPlatform.Windows2003]: "Windows 2003",
  [ConfigPlatform.Windows2000]: "Windows 2000",
  [ConfigPlatform.LinuxX64]: "Linux",
  [ConfigPlatform.Mac]: "macOS",
};

export { InstallerPlatform as Platform };
export const mapInstallerPlatformToConfigPlatform = (
  platform: string | InstallerPlatform,
): ConfigPlatform | undefined => {
  switch (platform) {
    case InstallerPlatform.Windows:
    case InstallerPlatform.WindowsX64:
      return ConfigPlatform.Windows;
    case InstallerPlatform.Windows7:
    case InstallerPlatform.Windows7X64:
      return ConfigPlatform.Windows7;
    case InstallerPlatform.Windows2003:
    case InstallerPlatform.Windows2003X64:
    case InstallerPlatform.Windows2003X86:
      return ConfigPlatform.Windows2003;
    case InstallerPlatform.Windows2000:
    case InstallerPlatform.Windows2000X64:
    case InstallerPlatform.Windows2000X86:
      return ConfigPlatform.Windows2000;
    case InstallerPlatform.LinuxX64:
      return ConfigPlatform.LinuxX64;
    case InstallerPlatform.Mac:
      return ConfigPlatform.Mac;
    default:
      return undefined;
  }
};

export const mapConfigPlatformToInstallerPlatform = (
  platform: ConfigPlatform | InstallerPlatform | undefined,
): InstallerPlatform | undefined => {
  switch (platform) {
    case ConfigPlatform.Windows:
      return InstallerPlatform.WindowsX64;
    case ConfigPlatform.Windows7:
      return InstallerPlatform.Windows7X64;
    case ConfigPlatform.Windows2003:
      return InstallerPlatform.Windows2003X64;
    case ConfigPlatform.Windows2000:
      return InstallerPlatform.Windows2000X64;
    case ConfigPlatform.LinuxX64:
      return InstallerPlatform.LinuxX64;
    case ConfigPlatform.Mac:
      return InstallerPlatform.Mac;
    default:
      return platform;
  }
};
